<script>

	import { mapState } from 'vuex'

	import Navigation from '@/components/Navigation/Navigation'
	import ModalBox from '@/components/ModalBox/ModalBox'
	import Notification from '@/components/Notification/Notification'

	import 'normalize.css'
	import './styles/style.scss'

	export default {
		name: 'app',
		components: {
			Notification,
			Navigation,
			ModalBox,
		},
		created () {
			this.$store.dispatch('verifyUser')
		},
		computed: mapState({
			'isLoggedIn': state => state.user.isLoggedIn,
			'restricted': state => state.user.restrictedQuestions,
		}),
		methods: {
			showNavs () {
				const noNavRoutes = [
					'/login',
					'/register',
				]
				const currentRoute = this.$router.currentRoute.path;
				return noNavRoutes.some((key, value) => {
					return key === currentRoute;
				})
			}
		},
		watch: {
			isLoggedIn (loginState) {
				this.$store.dispatch('fetchSubscriptions', loginState)
			},
			restricted(isRestricted) {
				if (isRestricted === false) {
					this.$store.dispatch('fetchSubscriptions', this.isLoggedIn)
				}
			},
		}
	}

</script>

<template>
	<div id='app' class='app'>
		<div v-bind:class="{ 'app-container': true, 'no-nav': showNavs(), 'no-footer': showNavs() }">
			<Notification />
			<Navigation />
			<ModalBox />
			<router-view />
		</div>
	</div>
</template>


// WEBPACK FOOTER //
// src/containers/App/App.vue